export default __webpack_public_path__ + "static/media/audio-wave.c1d9d64e.gif";